import { DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CheckboxState } from '~src/commonInfra/components/checkbox/CheckboxState';
import { PlainTextCell } from '~src/spacesPlatform/components/ListView/dataGridCells/PlainTextAndNumberCells';
import { CommonColumn } from '~src/spacesPlatform/components/ListView/types/Columns';
import { IGroup } from '~src/userManagement/groups/serverApi/types/IGroup';

import { IGroupSetGroupInfo } from '../models/IGroupSetInfo';
import { AddGroupsToGroupSetGridCellFormatterFactory } from './AddGroupsToGroupSetCellFormatter';
import { dataGridContainerStyle, dataGridRowHeight, dataGridStyle } from './styles/AddGroupsToGroupSetDialogStyles';


export enum AddGroupsToGroupSetDataKeys {
    Select = 'selected',
    GroupName = 'groupName'
}

export namespace AddGroupsToGroupSetTypes {
  export interface GridProps {
    emptyChild: JSX.Element;
    groupList: IGroup[];
    inGroupSetGroupsList: IGroupSetGroupInfo[];
    rowCheckboxState: _.Dictionary<string>;
    handleRowCheckboxChange: (rowData: Partial<IGroup>) => void;
    shouldAskForNextPage: (dataGridEndIndex: number) => boolean;
    askForNextPage: () => void;
  }

  export interface GridState {
    selectedGroupIds: string[];
    selectedIGroupInfoSet: Set<IGroup>;
  }

  export interface CheckboxCellData {
    checkboxState: CheckboxState;
    isCheckboxEnabled: boolean;
    onCheckboxChanged: () => void;
  }

  export interface Column extends DataGrid.Column {
    checkboxState?: CheckboxState;
    isCheckboxEnabled?: boolean;
    onCheckboxChanged?: () => void;
  }

  export interface Row extends DataGrid.Row {
  }
}

export class AddGroupsToGroupSetGrid extends React.Component<AddGroupsToGroupSetTypes.GridProps, AddGroupsToGroupSetTypes.GridState>{

    public rows: DataGrid.Row[] = [];
    private cols: DataGrid.Column[] = [];

    private getRowStore = (): DataGrid.RowStore => {
        return {
          getItems: (start: number, end: number, rowHandler: (rows: DataGrid.Row[]) => void) => {
            rowHandler(this.rows);
            if (this.props.shouldAskForNextPage(end)) {
              this.props.askForNextPage();
            }
          }
        } as DataGrid.RowStore;
    };

    private generateContent = (): void => {
        this.cols = this.generateCols();
        this.rows = this.generateRows();
    };

    private generateCols = (): DataGrid.Column[] => {
        const columns: AddGroupsToGroupSetTypes.Column[] = [];
        columns.push({
            name: CommonColumn.Select,
            dataKey: AddGroupsToGroupSetDataKeys.Select,
            headerText: '',
            resizable: false,
            sortable: false,
            cellFormatter: AddGroupsToGroupSetGridCellFormatterFactory
        });
        columns.push({
            name: CommonColumn.GroupName,
            dataKey: AddGroupsToGroupSetDataKeys.GroupName,
            sortable: true,
            direction: 'asc',
            growToFit: true,
            headerText: Messages.column_groupName(),
            cellFormatter: PlainTextCell(AddGroupsToGroupSetDataKeys.GroupName)
        });
        return columns;
    };

    private generateRows(): DataGrid.Row[] {
        let rows: AddGroupsToGroupSetTypes.Row[] = [];
        let nextRowIndex: number = 0;
        this.props.groupList.forEach(rowData => {
            let rowItemData: { [key: string]: {} } = {};
            const currentRowIndex = nextRowIndex++;
            const groupAlreadyInGroupSet: boolean = this.props.inGroupSetGroupsList.some(groupInGroupSet => {
              return rowData.name === groupInGroupSet.name;
            });
            let checkboxCellData: AddGroupsToGroupSetTypes.CheckboxCellData = {
              checkboxState: groupAlreadyInGroupSet ? CheckboxState.checked : this.props.rowCheckboxState[rowData.id],
              isCheckboxEnabled: !(groupAlreadyInGroupSet),
              onCheckboxChanged: () => { this.props.handleRowCheckboxChange(rowData); }
            };
            rowItemData[AddGroupsToGroupSetDataKeys.Select] = checkboxCellData;
            rowItemData[AddGroupsToGroupSetDataKeys.GroupName] = rowData.name;
            rows.push({
              key: (currentRowIndex).toString(),
              data: rowItemData
            });
        });
        return rows;
    }

    public render(): JSX.Element {
        this.generateContent();
        return <div className={dataGridContainerStyle}>
            <div className={'tb-spaces-list-view'}>
                <DataGrid
                config= {{
                    rowOuterHeight: dataGridRowHeight,
                    rememberLastScrollPos: true
                }}
                emptyChild={this.props.emptyChild}
                cols={this.cols}
                rowStore={this.getRowStore()}
                showVerticalGridLines={false}
                showHorizontalGridLines={false}
                showRowBanding={false}
                style={dataGridStyle}
                />
            </div>
        </div>;
    }
}